import { useCallback, useMemo } from 'react'
import { trackEvent } from '../../../utils/segmentService'
import { normalizeValue, normalizeExtraData } from '../../../utils/analytics'
import { SEARCH_PLATFORMS } from '../../../constants/searchTracking'

const createSearchSessionId = () => {
  if (typeof crypto !== 'undefined' && crypto?.randomUUID) {
    return crypto.randomUUID()
  }
  return `search_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`
}

export const useSearchTracking = () => {
  const searchSessionId = useMemo(() => createSearchSessionId(), [])

  // Track search interactions
  const trackSearchEvent = useCallback(
    ({
      event,
      action,
      label = '',
      platform = SEARCH_PLATFORMS.MOBILE,
      source = 'search_page',
      type = '',
      ...extra
    }) => {
      if (!event || !action) return

      const eventData = {
        action, // SEARCH_ACTIONS
        context_label: normalizeValue(label),
        platform,
        source,
        type,
        search_session_id: searchSessionId,
        ...normalizeExtraData(extra)
      }
      trackEvent(event, eventData)
    },
    [searchSessionId]
  )

  return { trackSearchEvent, searchSessionId }
}
